import {
  commonAPI,
  defaultGuid,
  defaultHashMap,
  defaultRule,
  defaultToken,
  userHashMap,
  userRule,
} from '@/constant/auth';
import { userCache } from '@/store/userInfo';
import { cryptoMd5 } from './md5';

export const auth = async (path: string, paramStr: string) => {
  const now = (Date.now() / 1000).toFixed(0);
  let token = defaultToken;
  let guid = defaultGuid;
  let indexRule = defaultRule;
  let hashMap = defaultHashMap;

  if (!commonAPI.includes(path)) {
    // 静默登录，等待userInfo有值

    if (!commonAPI.includes(path)) {
      try {
        const { guid: uGuid, token: uToken } = userCache;
        guid = uGuid;
        token = uToken;
        indexRule = userRule;
        hashMap = userHashMap;
      } catch (_err) {
        console.warn('guid/token 获取超时，使用默认值');
      }
    }
  }

  const hexStr = indexRule.map((index) => token[index]).join('');
  const index = parseInt(hexStr, 16) % hashMap.length;
  const _token = hashMap[index]?.map((index) => token[index]).join('');
  const sign = cryptoMd5(`${now}${guid}${path}${_token}${paramStr}`);
  const headers: Record<string, string> = {
    'app-time': now,
    'app-guid': guid,
    'app-sign': sign,
    'Content-Type': 'application/json',
  };
  const shouldAttachApiKey =
    userCache.isSuperAdmin !== 1 &&
    !!userCache.activeApiKey &&
    (userCache.activeApiKeyAppUuid
      ? userCache.activeApiKeyAppUuid === userCache.currentAppUuid
      : true);
  if (shouldAttachApiKey) {
    headers['X-API-Key'] = userCache.activeApiKey;
  }
  return headers;
};
